function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import { SvgIcon } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var DayNight = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsxs(SvgIcon, _extends({
    "data-testid": "DayNightIcon"
  }, props, {
    ref: ref,
    children: [/*#__PURE__*/_jsx("rect", {
      width: "24",
      height: "2",
      x: "2.808",
      y: "19.778",
      opacity: ".6",
      rx: "1",
      transform: "rotate(-45 2.808 19.778)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M9 1.667c.368 0 .667.298.667.666v2H8.333v-2c0-.368.299-.666.667-.666zM7.865 12.135l4.27-4.27a3.335 3.335 0 1 0-4.27 4.27zM1.667 9c0-.368.298-.667.666-.667h2v1.334h-2A.667.667 0 0 1 1.667 9zM3.815 3.815c.26-.26.682-.26.942 0l1.415 1.414-.943.943-1.414-1.415a.667.667 0 0 1 0-.942zM12.771 6.172l-.943-.943 1.415-1.414a.667.667 0 1 1 .942.942l-1.414 1.415zM3.815 14.185a.667.667 0 0 1 0-.942l1.414-1.415.943.943-1.415 1.414a.667.667 0 0 1-.942 0zM18.686 20.434a4.43 4.43 0 0 1-1.055-7.772c.218-.155.142-.52-.124-.502a5.213 5.213 0 1 0 4.112 8.818c.185-.192-.047-.485-.305-.418a4.41 4.41 0 0 1-2.628-.126z"
    })]
  }));
});
DayNight.displayName = 'DayNightIcon';
export default DayNight;